import { SxProps, Typography } from '@mui/material';
import React from 'react';
import { vars } from '../../../../../Theme';
import AppTooltip from '../../../../General/AppTooltip/AppTooltip';

/** Base tag text styles. */
const textSx: SxProps = {
    color: vars.white,
    borderRadius: 5,
    lineHeight: 1,
    height: 20,
    flex: 0,
    py: 0.5,
    px: 1,
    mr: 1,
    minWidth: '40px',
    textAlign: 'center',
};

/**
 * Gets the text content and background color for a vulnerability tag.
 * @param cvssScore - Vulnerability CVSS score.
 */
const getTagProps = (cvssScore: string) => {
    const intCvssScore: number = parseInt(cvssScore);

    if (intCvssScore <= 1) {
        return [cvssScore, '#00C400'];
    } else if (intCvssScore <= 2 && intCvssScore > 1) {
        return [cvssScore, '#00E020'];
    } else if (intCvssScore <= 3 && intCvssScore > 2) {
        return [cvssScore, '#00F000'];
    } else if (intCvssScore <= 4 && intCvssScore > 3) {
        return [cvssScore, '#D1FF00'];
    } else if (intCvssScore <= 5 && intCvssScore > 4) {
        return [cvssScore, '#FFE000'];
    } else if (intCvssScore <= 6 && intCvssScore > 5) {
        return [cvssScore, '#FFCC00'];
    } else if (intCvssScore <= 7 && intCvssScore > 6) {
        return [cvssScore, '#FFBC10'];
    } else if (intCvssScore <= 8 && intCvssScore > 7) {
        return [cvssScore, '#FF9C20'];
    } else if (intCvssScore <= 9 && intCvssScore > 8) {
        return [cvssScore, '#FF8000'];
    } else if (intCvssScore <= 10 && intCvssScore > 9) {
        return [cvssScore, '#FF0000'];
    } else {
        return ['NaN', vars.lightGray];
    }
};

/**
 * Component that shows a vulnerability's CVSS score as a colourful 'tag'.
 */
export default (props: { cvssScore: string; style?: SxProps }) => {
    /** Calculate tag props. */
    const [tag, bgcolor] = getTagProps(props.cvssScore);

    const style = props.style;

    return (
        <AppTooltip title={tag}>
            <Typography
                variant='h6'
                fontSize={12}
                sx={{ ...textSx, bgcolor, pl: 1, ml: 2, ...style }}
                children={tag}
            />
        </AppTooltip>
    );
};
